import api from 'config/api';

export const sendJob = (data: any) => (
  api.post('/api/jobs', data)
);

export const fetchJobs = (pageSize: number) => (
  api.get(`/api/jobs?pageSize=${pageSize}`)
);
